import { render, staticRenderFns } from "./SupervisorCard.vue?vue&type=template&id=befd9d26&scoped=true"
import script from "./SupervisorCard.vue?vue&type=script&lang=js"
export * from "./SupervisorCard.vue?vue&type=script&lang=js"
import style0 from "./SupervisorCard.vue?vue&type=style&index=0&id=befd9d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befd9d26",
  null
  
)

export default component.exports